export default function(state, element) {
  const position = element.selectionStart + 1;
  const value =
    state.slice(0, position - 1) +
    ' ' +
    state.slice(position - 1, state.length);
  return { value, position };
}
